<div class="row">
  <div class="col-xs-12 text-right">
    <ul class="list-inline options">
      <li id="link-roubo-furto" *ngIf="isRouboFurto">
        <a data-toggle="modal" class="btn-roubo-furto" (click)="openModalRouboFurto(insuranceRouboFurto)">
          Cotar Seguro
        </a>
        <saiba-mais [texto]="textSaibaMais" [backgroundBlue]="isBackgroundBlue" style="position: absolute; margin-top: -73px;"></saiba-mais>
      </li>
      <li>
        <a data-toggle="modal" class="icon-full" (click)="openModal(insurance)" style="padding-top: 6px;">
          <em class="fa fa-gear"></em>
        </a>
      </li>
    </ul>
  </div>
</div>

<ng-template #msgErroInsurance>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClickClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-size: 2rem; color: #002c7c;">Não existe cotação para os parâmetros informados.</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="onClickClose()" class="btn btn-border-orange pull-left" data-dismiss="modal">Fechar</button>
  </div>
</ng-template>

<ng-template #insurance>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClickClose()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3>PRODUTOS</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-10 col-xs-offset-1">
            <slider-retorno [retornoMax]="retornoMax" [(retorno)]="retorno"></slider-retorno>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-10 col-xs-offset-1 text-center">
            <h3>{{retorno}}</h3>
          </div>
        </div>
        <hr>

        <div *ngIf="exibeSeguro">
          <div *ngIf="hasGrupoSeguro()">
            <div *ngFor="let grupo of gruposSeguros">
              <h3>{{grupo.descricao}}</h3>
              <div class="radio" *ngFor="let seg of grupo.seguros">
                <input type="radio" name="radioSeguro-{{grupo.id}}" [id]="seg.id" [value]="seg.descricao"
                  (change)="onSelectionSeguro(seg.id, grupo.id)" [checked]="checkSeguro(seg.id)">
                <label class="label-descricao" [for]="seg.id">
                    <div class="label-descricao__texto-seguros">{{seg.descricao}}</div>
                    <div class="insurance-desc">Limite de cobertura:
                      {{seg.valorMaximo || 0 | currency:'BRL':'symbol':'1.2-2'}}</div>
                </label>
                <saiba-mais [texto]="seg.saibaMais"></saiba-mais>
              </div>
              <div class="radio">
                <input type="radio" name="radioSeguro-{{grupo.id}}" id="nenhumSeguro-{{grupo.id}}" value="NENHUM_SEGURO"
                  (change)="onSelectionSeguro(0, grupo.id)" [checked]="checkSeguroNone(grupo.id)">
                <label class="label-descricao" for="nenhumSeguro-{{grupo.id}}">NENHUM</label>
              </div>
            </div>
          </div>

          <div class="radio" *ngIf="!hasGrupoSeguro()">
            <input type="radio" name="semOpcoes" id="semOpcoes" [disabled]="true">
            <label for="semOpcoes">Não há opções</label>
            <saiba-mais [texto]="'Não há opções de seguros disponíveis para este cliente.'"></saiba-mais>
          </div>
          <hr>

          <div *ngIf="hasGrupoAssistencia()">
            <div *ngFor="let grupo of gruposAssistencias">
              <h3>{{grupo.descricao}}</h3>
              <div class="radio" *ngFor="let assistencia of grupo.assistencias">
                <input type="radio" name="radioAssistencia-{{grupo.id}}" [id]="'assistencia-' + assistencia.id"
                  [value]="assistencia.descricao" (change)="onSelectionAssistencia(assistencia.id, grupo.id)"
                  [checked]="checkAssistencia(assistencia.id)">
                <label class="label-descricao" [for]="'assistencia-' + assistencia.id">
                  <div class="label-descricao__texto">{{assistencia.descricao}}</div>
                </label>
                <saiba-mais [texto]="assistencia.saibaMais"></saiba-mais>
              </div>
              <div class="radio">
                <input type="radio" name="radioAssistencia-{{grupo.id}}" id="nenhumAssistencia-{{grupo.id}}"
                  value="NENHUM_ASSISTENCIA" (change)="onSelectionAssistencia(0, grupo.id)"
                  [checked]="checkAssistenciaNone(grupo.id)">
                <label class="label-descricao" for="nenhumAssistencia-{{grupo.id}}">NENHUM</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onClickClose()" class="btn btn-border-orange pull-left" data-dismiss="modal">Voltar</button>
    <button type="button" (click)="onSaveClick()" class="btn btn-full-orange pull-right" data-dismiss="modal">Salvar</button>
  </div>

</ng-template>

<ng-template #insuranceRouboFurto>
  <form #formRouboFurto="ngForm" class="forms" id="formRouboForto">
    <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClickClose()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="row" [ngClass]="{'hide': passo == 2}">
        <div class="form-group">
          <span class="icon user"></span>
          <div class="inputs">
            <h4 class="title-input">Você possui outro veículo?</h4>
            <div class="input-box" data-toggle="buttons">
              <label class="btn btn-default btn-circle btn-lg" (click)="simulacaoRequest.possuiOutroVeic = true">
                <input type="radio" name="possuiOutroVeiculo" value="S">
              </label>
              <span class="radio-label">Sim</span>
              <label class="btn btn-default btn-circle btn-lg active" (click)="simulacaoRequest.possuiOutroVeic = false">
                <input type="radio" name="possuiOutroVeiculo" value="N">
              </label>
              <span class="radio-label">Não</span>
            </div>
            <label class="title-input pt-20">Nome</label>
            <input
              maxlength="60"
              type="text"
              class="form-control"
              name="nome"
              #segNome="ngModel"
              required
              requiredMessage="O Campo Nome é obrigatório"
              placeholder="Nome"
              [(ngModel)]="simulacaoRequest.nome"
              appShowErrorMessages>
            <label class="title-input pt-20">CPF</label>
            <input
              name="cpf-cliente"
              type="text"
              class="form-control"
              mask-number
              [mask]="'999.999.999-99'"
              placeholder="Digite apenas numeros"
              #segCPF="ngModel"
              required
              requiredMessage="O Campo CPF é obrigatório"
              [(ngModel)]="simulacaoRequest.cpfCnpj"
              appShowErrorMessages
            />
            <label class="title-input pt-20">Data de Nascimento</label>
            <input
              name="data-nascimento-cliente"
              type="text"
              mask-number
              [mask]="'99/99/9999'"
              placeholder="00/00/0000"
              class="form-control"
              required
              requiredMessage="O Campo Data de Nascimento é obrigatório"
              #segDataNascimento="ngModel"
              [(ngModel)]="simulacaoRequest.dtNascimento"
              appShowErrorMessages
            />
            <label class="title-input pt-20">Estado civil</label>
            <select class="form-control" name="estado-civil"
                    required
                    requiredMessage="Selecione um Estado civil"
                    [(ngModel)]="simulacaoRequest.estadoCivil"
                    #segEstadoCivil="ngModel"
                    appShowErrorMessages>
              <option value="1">Casado União Estável</option>
              <option value="2">Solteiro</option>
              <option value="3">Separado/ Divorciado/ Outros</option>
            </select>
            <label class="title-input pt-20">Sexo</label>
            <select class="form-control" name="sexo" required [(ngModel)]="simulacaoRequest.sexo"
                    #segSexo="ngModel"
                    requiredMessage="Selecione um Sexo "
                    appShowErrorMessages>
              <option value="1">Feminino</option>
              <option value="2">Masculino</option>
            </select>
            <h4 class="title-input pt-20">Você será o principal condutor?
              <saiba-mais [texto]="textPrincipalCondutor" style="position: absolute; margin-top: -17px; margin-left: 50px;"></saiba-mais></h4>
            <div class="input-box" data-toggle="buttons">
              <label class="btn btn-default btn-circle btn-lg active" (click)="principalCondutorChange('S');">
                <input type="radio" name="principalCondutor" value="S">
              </label>
              <span class="radio-label">Sim</span>
              <label class="btn btn-default btn-circle btn-lg" (click)="principalCondutorChange('N');">
                <input type="radio" name="principalCondutor" value="N">
              </label>
              <span class="radio-label">Não</span>
            </div>
            <div *ngIf="!isPrincipalCondutor">
              <label class="title-input pt-20">Nome principal condutor</label>
              <input
                maxlength="60"
                type="text"
                class="form-control"
                name="nome-condutor"
                required
                requiredMessage="O Campo Nome principal condutor é obrigatório"
                placeholder="Nome principal condutor"
                [(ngModel)]="simulacaoRequest.nomePrincipalCondutor"
                #segNomePrincipalCondutor="ngModel"
                appShowErrorMessages>
              <label class="title-input pt-20">CPF principal condutor</label>
              <input
                name="cpf-cliente-condutor"
                type="text"
                class="form-control"
                mask-number
                [mask]="'999.999.999-99'"
                placeholder="Digite apenas numeros"
                required
                requiredMessage="O Campo CPF principal condutor é obrigatório"
                [(ngModel)]="simulacaoRequest.cpfCnpjPrincipalCondutor"
                #segCpfCnpjPrincipalCondutor="ngModel"
                appShowErrorMessages
              />
              <label class="title-input pt-20">Data de Nascimento principal condutor</label>
              <input
                name="data-nascimento-cliente-condutor"
                type="text"
                mask-number
                [mask]="'99/99/9999'"
                placeholder="00/00/0000"
                class="form-control"
                required
                requiredMessage="A Data de Nascimento principal condutor é obrigatória"
                [(ngModel)]="simulacaoRequest.dtNascimentoPrincipalCondutor"
                #segDtNascimentoPrincipalCondutor="ngModel"
                appShowErrorMessages
              />
              <label class="title-input pt-20">Estado civil principal condutor</label>
              <select class="form-control" name="estado-civil-principal-condutor" required [(ngModel)]="simulacaoRequest.estadoCivilPrincipalCondutor"
                      #segEstadoCivilPrincipalCondutor="ngModel"
                      requiredMessage="Selecione um Estado civil para o principal condutor"
                      appShowErrorMessages>
                <option value="1">Casado União Estável</option>
                <option value="2">Solteiro</option>
                <option value="3">Separado/ Divorciado/ Outros</option>
              </select>
              <label class="title-input pt-20">Sexo principal condutor</label>
              <select class="form-control" name="sexo-principal-condutor" required [(ngModel)]="simulacaoRequest.sexoPrincipalCondutor"
                      #segSexoPrincipalCondutor="ngModel"
                      requiredMessage="Selecione um Sexo para o principal condutor"
                      appShowErrorMessages>
                <option value="1">Feminino</option>
                <option value="2">Masculino</option>
              </select>
            </div>
            <label class="title-input pt-20">CEP que a moto passa a noite</label>
            <input
              name="cep-veiculo-noite"
              type="text"
              mask-number
              [mask]="'99999-999'"
              placeholder="00000-000"
              class="form-control"
              required
              requiredMessage="O CEP pernoite é obrigatório"
              [(ngModel)]="simulacaoRequest.cepPernoite"
              #segCepPernoite="ngModel"
              appShowErrorMessages
            />
          </div>
        </div>
      </div>
      <div class="row" [ngClass]="{'hide': passo == 1}">
        <div class="form-group">
          <span class="icon motocicleta"></span>
          <div class="inputs" *ngIf="questions?.questions?.length">
            <h4 class="title-input title-input2">Tipo de garagem</h4>
            <label class="title-input pt-20">{{questions.questions[0].question}}</label>
            <select class="form-control" name="pergunta1" required
                    [(ngModel)]="simulacaoRequest.pergunta1"
                    requiredMessage="Selecione uma opção"
                    appShowErrorMessages
                    #pergunta1="ngModel">
              <option *ngFor="let r1 of questions.questions[0].answers" [value]="r1.id">{{r1.answer}}</option>
            </select>
            <label class="title-input pt-20">{{questions.questions[1].question}}</label>
            <select class="form-control" name="pergunta2" required
                    [(ngModel)]="simulacaoRequest.pergunta2"
                    requiredMessage="Selecione uma opção"
                    appShowErrorMessages
                    #pergunta2="ngModel">
              <option *ngFor="let r2 of questions.questions[1].answers" [value]="r2.id">{{r2.answer}}</option>
            </select>
            <label class="title-input pt-20">{{questions.questions[2].question}}</label>
            <select class="form-control" name="pergunta3" required
                    [(ngModel)]="simulacaoRequest.pergunta3"
                    requiredMessage="Selecione uma opção"
                    appShowErrorMessages
                    #pergunta3="ngModel">
              <option *ngFor="let r3 of questions.questions[2].answers" [value]="r3.id">{{r3.answer}}</option>
            </select>
            <label class="title-input pt-20">{{questions.questions[3].question}}</label>
            <select class="form-control" name="pergunta4" required
                    [(ngModel)]="simulacaoRequest.pergunta4"
                    requiredMessage="Selecione uma opção"
                    appShowErrorMessages
                    #pergunta4="ngModel">
              <option *ngFor="let r4 of questions.questions[3].answers" [value]="r4.id">{{r4.answer}}</option>
            </select>
            <h4 class="title-input title-input2 pt-20">Como você usa a Moto?</h4>
            <label class="title-input pt-20">{{questions.questions[5].question}}</label>
            <select class="form-control" name="utilizacaoDut" required
                    [(ngModel)]="simulacaoRequest.utilizacaoDut"
                    requiredMessage="Selecione um tipo de Utilização"
                    appShowErrorMessages
                    #pergunta5="ngModel">
              <option *ngFor="let r5 of questions.questions[5].answers" [value]="r5.id">{{r5.answer}}</option>
            </select>
            <label class="title-input pt-20" *ngIf="simulacaoRequest.utilizacaoDut == 1">{{questions.questions[4].question}}</label>
            <select *ngIf="simulacaoRequest.utilizacaoDut == 1" class="form-control" name="tipoUtilizacao"
                    [(ngModel)]="simulacaoRequest.tipoUtilizacao"
                    #pergunta6="ngModel">
              <option *ngFor="let r6 of questions.questions[4].answers" [value]="r6.id">{{r6.answer}}</option>
            </select>
          </div>
        </div>
      </div>
      <div style="text-align: center;">
        <button type="button" [disabled]="passo == 1" (click)="passo = 1" class="btn btn-sm btn-full-orange">1. Voltar</button>
        &nbsp;&nbsp;&nbsp;
        <button type="button" [disabled]="passo == 2" (click)="passo = 2" class="btn btn-sm btn-full-orange">2. Continuar</button>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="onClickClose()" class="btn btn-border-orange pull-left" data-dismiss="modal">Fechar</button>
      <button type="button" [disabled]="!formRouboFurto.form.valid" (click)="onSaveInfoPropostaClick()" class="btn btn-full-orange pull-right" data-dismiss="modal">Salvar</button>
    </div>
  </form>
</ng-template>
